import React, { useRef, useState } from "react";
import { ABtn, AResult, AScore } from "./arcadeUi";
import { sfx } from "@/lib/soundfx";
import { useInput, useLoop, Joystick, Token, dist, clamp } from "./arena";

const rnd = (a, b) => a + Math.random() * (b - a);
const mkPlat = () => Array.from({ length: 3 }).map(() => ({ x: rnd(15, 85), y: rnd(20, 78), w: rnd(16, 24), h: rnd(10, 14) }));
const SURVIVE = 30;

// Oonch-Neench: a catcher chases you. You're safe only when standing on high (oonch) ground.
export default function OonchNeench() {
  const [phase, setPhase] = useState("ready");
  const [time, setTime] = useState(0);
  const [, setTick] = useState(0);
  const player = useRef({ x: 50, y: 88 });
  const cat = useRef({ x: 50, y: 8 });
  const plats = useRef(mkPlat());
  const shuffle = useRef(0);
  const { dir, setJoy } = useInput();

  const onSafe = (p) => plats.current.some((r) => Math.abs(p.x - r.x) < r.w / 2 && Math.abs(p.y - r.y) < r.h / 2);

  const start = () => { player.current = { x: 50, y: 88 }; cat.current = { x: 50, y: 8 }; plats.current = mkPlat(); setTime(0); shuffle.current = 0; setPhase("play"); };

  useLoop(phase === "play", (dt) => {
    const p = player.current, c = cat.current, d = dir();
    p.x = clamp(p.x + d.x * 40 * dt, 3, 97); p.y = clamp(p.y + d.y * 40 * dt, 3, 97);
    // catcher chases
    let ax = p.x - c.x, ay = p.y - c.y; const m = Math.hypot(ax, ay) || 1;
    c.x = clamp(c.x + (ax / m) * 24 * dt, 3, 97); c.y = clamp(c.y + (ay / m) * 24 * dt, 3, 97);
    shuffle.current += dt; if (shuffle.current > 7) { shuffle.current = 0; plats.current = mkPlat(); }
    if (dist(p, c) < 5.5 && !onSafe(p)) { setPhase("lose"); return; }
    setTime((t) => { const nt = t + dt; if (nt >= SURVIVE) { setPhase("win"); sfx.win?.(); return SURVIVE; } return nt; });
    setTick((x) => (x + 1) % 1e6);
  });

  const safe = onSafe(player.current);
  return (
    <div className="w-full text-center">
      <div className="flex justify-center gap-2">
        <AScore label="Survive" value={`${Math.ceil(SURVIVE - time)}s`} />
        <AScore label="Status" value={phase === "play" ? (safe ? "SAFE ⬆" : "RUN!") : "—"} />
      </div>
      <p className="my-2 text-sm text-kirana-brown/70">Reach the raised OONCH blocks to be safe. Stay off the ground when the catcher is near! Blocks move every few seconds.</p>
      <div data-testid="on-arena" className="relative mx-auto mb-3 h-72 w-full max-w-md overflow-hidden rounded-md border-2 border-kirana-border bg-gradient-to-b from-[#caa472] to-[#a97f4e]">
        {plats.current.map((r, i) => (
          <div key={i} className="absolute rounded-md border-2 border-[#3a2617] bg-[#8FBF6B]" style={{ left: `${r.x - r.w / 2}%`, top: `${r.y - r.h / 2}%`, width: `${r.w}%`, height: `${r.h}%`, boxShadow: "0 3px 0 rgba(0,0,0,0.3)" }} />
        ))}
        {phase !== "ready" && <Token testid="on-player" x={player.current.x} y={player.current.y} color={safe ? "#2A9D8F" : "#1D6FB8"} label="😀" size={32} z={8} ring={safe} />}
        {phase !== "ready" && <Token testid="on-cat" x={cat.current.x} y={cat.current.y} color="#8B1E3F" label="👹" size={32} z={7} />}
      </div>
      {phase === "play" && <div className="flex items-center justify-center gap-4"><Joystick onMove={setJoy} /><span className="hidden text-xs text-kirana-brown/60 sm:inline">Move: WASD / Arrows</span></div>}
      <div className="mt-3">
        {phase === "ready" && <ABtn data-testid="on-start" onClick={start} tone="gold" className="px-8 py-3">Start</ABtn>}
        {(phase === "win" || phase === "lose") && (<><AResult testId="on-result" win={phase === "win"} text={phase === "win" ? "Bach gaye! Survived! 🎉" : "Pakde gaye on neench! 😅"} /><div className="mt-3 flex justify-center"><ABtn data-testid="on-again" onClick={start} tone="green">Play Again</ABtn></div></>)}
      </div>
    </div>
  );
}
